import { Button, Typography } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useReducer, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { setLoading } from "../../store/common/commonActions";
import {
  storeProductCount,
  storeProducts,
  storeReleasesEnumsValue,
} from "../../store/products/productsActions";
import ReleasesHeaderFilters from "../releasesHeaderFilters";
import { CloseIcon, RightArrow } from "../../assets/images";
import Localize from "../../utils/string";
import { releasesFilter } from "../../store/products/productsAsyncActions";
import { title } from "process";
import { ArrowRightOutlined } from "@ant-design/icons";

interface Props {
  formats: any;
  generic: any;
  setMoreData: any;
  scrollToTop: any;
  checkMobile?: boolean;
  isVisible?: boolean;
  isSetVisible?: any;
  setFilterShow?: any;
  filterShow?: boolean;
  rsdSpecialsVisible?: any;
  setStartIndex?: any;
  initialFunction?: any;
  setCurrentMobileFilter?: any;
  currentMobileFilter?: any;
  setChangeMobileFunction?: any;
  changeMobileFunction?: any;
  isReleaseWeekVisible?: boolean;
  setIsReleaseWeekVisible?: any;
  setFilterLabelName?: any;
  filterLabelName?: any;
  setSelectedWeekdays?: any;
  selectedWeekdays?: any;
  eventBus?: any;
}

const formatComma = ["7", "10", "12"];

const specialFilter = [
  {
    title: Localize.NewReleases,
  },
  {
    title: Localize.ForthComing,
  },
  {
    title: Localize.Represses,
  },
  {
    title: Localize.FullCatalogue,
  },
];

const FiltersListing = (props: Props) => {
  const customClass = useSelector((state: any) => state.common.customClass);
  const params = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [genericId, setGenericId] = useState([] as any);
  const [formatName, setFormatName] = useState([] as any);
  const [genericName, setgenericName] = useState([] as any);
  const [labelId, setLabelId] = useState("");
  const {
    generic,
    formats,
    checkMobile,
    isVisible,
    isSetVisible,
    setFilterShow,
    filterShow,
    setStartIndex,
    initialFunction,
    setCurrentMobileFilter,
    currentMobileFilter,
    setChangeMobileFunction,
    changeMobileFunction,
    isReleaseWeekVisible,
    setIsReleaseWeekVisible,
    setFilterLabelName,
    filterLabelName,
    setSelectedWeekdays,
    selectedWeekdays,
    eventBus,
  } = props;
  // const [filterLabelName, setFilterLabelName] = useState([] as any);
  const [weekdays, setWeekDays] = useState<{ year: number; week: number }[]>(
    []
  );
  const [showFilterValue, setShowFilterValue] = useState<boolean>(false);
  const [mobileFilterName, setMobileFilterName] = useState<string[]>([
    "Music",
    "Formats",
    "Genre",
  ]);
  // const [currentMobileFilter, setCurrentMobileFilter] = useState<string | null>(
  //   null
  // );

  // const [changeMobileFunction, setChangeMobileFunction] =
  //   useState<boolean>(false);
  const [productReleaseEnumValue, setProductReleaseEnumValue] = useState(0);
  // const [selectedWeekdays, setSelectedWeekdays] = useState<number>(0);
  const [selectedYear, setSelectedYear] = useState<number>(0);
  const RSDAvailable: any = useSelector(
    (state: any) => state.products.RSDAvailable
  );
  const specialFilters = new URLSearchParams(window.location.search).get('productReleaseEnumValue') == '5' || RSDAvailable
    ? [...specialFilter, { title: Localize.RsdSpecials }]
    : specialFilter;
  useEffect(() => {
    if (customClass === "sub-header") {
    }
  }, [customClass]);

  // useEffect(() => {
  //   if (store_redirect_path === false) {
  //     // setProductReleaseEnumValue(1)
  //     dispatch(storeReleasesEnumsValue(1));
  //   }
  // }, [store_redirect_path]);

  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.pageYOffset;
      // Example condition: Hide navbar if scroll position is greater than 200px
      if (currentPosition > 520) {
        setShowFilterValue(true);
      } else {
        setShowFilterValue(false);
      }
    };

    handleScroll();

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) {
      setChangeMobileFunction(false);
    }
  }, [isVisible]);

  useEffect(() => {
    const queryString = window.location.search;
    const queryParams: any = new URLSearchParams(queryString);
    if (queryParams !== null) {
      let genreArray: any = [];
      let formatArray: any = [];
      let labelIdValue = "";

      // Parse and handle genre
      let genre = queryParams.get("genre");
      if (genre) {
        genreArray = genre.split(",");
        setGenericId(genreArray);
      } else {
        setGenericId([]);
      }

      // Parse and handle formatName
      let format = queryParams.get("formatName");
      if (format) {
        formatArray = format.split(",");
        setFormatName(formatArray);
      } else {
        setFormatName([]);
      }

      // Handle labelId
      if (queryParams.get("labelId")) {
        labelIdValue = queryParams.get("labelId");
        setLabelId(labelIdValue);
      }
      let week;
      let year;
      if (queryParams.get("weekNumber") && queryParams.get("weekYear")) {
        week = queryParams.get("weekNumber");
        year = queryParams.get("weekYear");
        if (week !== -1) {
          setSelectedWeekdays(week);
          setSelectedYear(year);
        }
      }

      let releaseEnum = 1;
      if (queryParams.get("productReleaseEnumValue")) {
        releaseEnum = +queryParams.get("productReleaseEnumValue") as number;
      }
      setProductReleaseEnumValue(releaseEnum);

      // Filter generic and update addFilterList with unique names from both filters
      const filteredGenericNames = generic
        .filter((gener: any) => genreArray.includes(gener?.id.toString()))
        .map((gener: any) => gener?.name);

      const filteredFormatNames = formatArray;
      // Combine and ensure unique names
      const combinedNames = [
        ...new Set([
          ...(releaseEnum >= 0 ? [specialFilters[releaseEnum - 1]?.title] : []),
          ...filteredFormatNames,
          ...filteredGenericNames,
        ]),
      ];

      setFilterLabelName(combinedNames);
    }
  }, [params, generic]); // Ensure dependencies are correctly set

  const getWeekNumber = (date: Date): number => {
    // Get the start of the year (January 1st of the current year)
  const startOfYear = new Date(date.getFullYear(), 0, 1);

  // Get the day of the week for January 1st (0 = Sunday, 6 = Saturday)
  const dayOfWeek = startOfYear.getDay();

  // Adjust the date to the first Thursday of the year
  const target = new Date(date.valueOf());
  target.setDate(target.getDate() - ((target.getDay() + 6) % 7) + 3); // Adjust to Thursday of the current week
  const firstThursday = target.valueOf();

  // Now set target to January 1st and find the first Thursday
  startOfYear.setMonth(0, 1); // Reset to January 1st
  if (startOfYear.getDay() !== 4) {
    startOfYear.setMonth(0, 1 + ((4 - startOfYear.getDay()) + 7) % 7); // Adjust to first Thursday
  }

  // Calculate the difference in days between the given date and the first Thursday
  const daysDifference = Math.floor((firstThursday - startOfYear.getTime()) / (1000 * 3600 * 24));

  // Calculate and return the ISO week number
  const weekNumber = Math.ceil((daysDifference + 1) / 7);

  return weekNumber;
  };

  const getNextAndPreviousWeeks = () => {
    const currentDate = new Date();
    const currentWeek = getWeekNumber(currentDate);

    // Get the total number of weeks in the current year (52 or 53 weeks)
    let totalWeeksInYear = getWeekNumber(
      new Date(currentDate.getFullYear(), 11, 31)
    );
    
    if (totalWeeksInYear > 52) {
      totalWeeksInYear = 52;
    }
    
    const nextWeeks: { year: number; week: number }[] = [];
    const prevWeeks: { year: number; week: number }[] = [];

    // Get next 12 weeks (handle year wrap-around)
    for (let i = 1; i <= 12; i++) {
      let nextWeek = currentWeek + i;
      let nextYear = currentDate.getFullYear();
      if (nextWeek > totalWeeksInYear) {
        nextWeek = nextWeek - totalWeeksInYear; // Wrap to start of next year
        nextYear++; // Move to next year
      }
      nextWeeks.push({ year: nextYear, week: nextWeek });
    }

    // Get previous 12 weeks (handle year wrap-around)
    for (let i = 0; i <= 11; i++) {
      let prevWeek = currentWeek - i;
      let prevYear = currentDate.getFullYear();
      if (prevWeek < 1) {
        prevWeek = totalWeeksInYear + prevWeek; // Wrap to the end of the previous year
        prevYear--; // Move to previous year
      }
      prevWeeks.push({ year: prevYear, week: prevWeek });
    }

    // Conditionally set weeks based on filterLabelName
    if (filterLabelName.includes(Localize.NewReleases)) {
      setWeekDays(prevWeeks); // Set previous weeks for New Releases
    } else if (filterLabelName.includes(Localize.ForthComing)) {
      setWeekDays(nextWeeks); // Set next weeks for ForthComing
    } else {
      setWeekDays([]); // Clear if neither condition is met
    }
  };

  useEffect(() => {
    getNextAndPreviousWeeks();
  }, [filterLabelName]);

  const loginResp = useSelector((state: any) => state.user.userSession);
  const handleClick = async (selectedOption: any, item: any) => {
    dispatch(setLoading(true));
    if(filterLabelName.includes(item.title)){
      return;
    }
    filterLabelName.push(item.title);
    const cID = loginResp?.userId ?? 0;
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    params.set("productReleaseEnumValue", selectedOption);
    setProductReleaseEnumValue(selectedOption);
    params.delete("weekNumber");
    params.delete("weekYear");
    setSelectedWeekdays(0);
    setSelectedYear(0);
    params.set("customerId", cID);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.push(newUrl);
  };

  const closeFilter = (
    event: any,
    isFormat: boolean,
    checkIndex: any,
    item: any,
    header?: boolean,
    isWeekDays?: boolean
  ) => {
    event.stopPropagation();
    if (specialFilters.some((filter) => filter.title === item)) {
      setProductReleaseEnumValue(-1);
      filterLabelName.splice(filterLabelName.indexOf(item), 1);
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      params.set("productReleaseEnumValue", "-1");
      params.set("weekNumber", "-1");
      params.set("weekYear", "-1");
      setSelectedWeekdays(0);
      setSelectedYear(0);
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.push(newUrl);
      props.initialFunction();
      return;
    }

    if (header) {
      if (formatName.includes(item)) {
        formatName.splice(formatName.indexOf(item), 1);
      } else {
        genericId.splice(genericName.indexOf(item), 1);
        genericName.splice(genericName.indexOf(item), 1);
      }
    } else {
      if (isFormat) {
        if (checkIndex !== -1) {
          formatName.splice(checkIndex, 1);
        }
      } else {
        if (checkIndex !== -1) {
          genericId.splice(checkIndex, 1);
          genericName.splice(checkIndex, 1);
        }
      }
    }
    if (isWeekDays && +selectedWeekdays === +item?.week) {
      const queryString = window.location.search;
      const params = new URLSearchParams(queryString);
      setSelectedWeekdays(0);
      setSelectedYear(0);
      params.set("weekNumber", "-1");
      params.set("weekYear", "-1");
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      history.push(newUrl);
    }

    const queryStringUrl = window.location.search;
    const params = new URLSearchParams(queryStringUrl);

    var queryString = "";
    if (params.has("productReleaseEnumValue")) {
      const produtReleaseVal = params.get("productReleaseEnumValue");
      queryString += `productReleaseEnumValue=${produtReleaseVal}`;
    }

    if (params.has("weekNumber") && params.has("weekYear")) {
      const weekNumber = params.get("weekNumber");
      const weekYear = params.get("weekYear");
      queryString += queryString !== "" ? "&" : "";
      queryString += `weekNumber=${weekNumber}`;
      queryString += queryString !== "" ? "&" : "";
      queryString += `weekYear=${weekYear}`;
    }

    if (params.has("customerId")) {
      const customerIdVal = params.get("customerId");
      queryString += queryString !== "" ? "&" : "";
      queryString += `customerId=${customerIdVal}`;
    }

    if (genericId.length) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `genre=${genericId.join(",")}`;
    }

    if (formatName.length) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `formatName=${formatName.join(",")}`;
    }

    if (labelId) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `labelId=${labelId}`;
    }

    var query = queryString ? `/releases?${queryString}` : `/releases`;
    history.push(query);
    props.initialFunction();
  };

  const clearAllFilter = (event: Event,isCheck?:boolean) => {
    event.preventDefault();
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    if(isCheck){
      setProductReleaseEnumValue(-1);
      params.set("productReleaseEnumValue", "-1");
      params.set("weekNumber", "-1");
      params.set("weekYear", "-1");
      setSelectedWeekdays(0);
      setSelectedYear(0);
    }
    setFormatName([]);
    setgenericName([]);
    params.delete("genre");
    params.delete("formatName");
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.push(newUrl);

    if (!filterShow) {
      props.initialFunction();
    }
  };

  const handelFilterMobile = (event: any, name: string) => {
    event.stopPropagation();
    isSetVisible(false);
    setCurrentMobileFilter(name);
    setTimeout(() => {
      isSetVisible(true);
      setChangeMobileFunction(true);
    }, 300);
  };

  const closeSpecialFilter = (event: any, item: any) => {
    event.stopPropagation();
    setProductReleaseEnumValue(-1);
    filterLabelName.splice(filterLabelName.indexOf(item.title), 1);
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    params.set("productReleaseEnumValue", "-1");
    params.set("weekNumber", "-1");
    params.set("weekYear", "-1");
    setSelectedWeekdays(0);
    setSelectedYear(0);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    history.push(newUrl);
  };

  const filterSelection = (
    isFormat: boolean,
    checkIndex: any,
    item: any,
    isWeekDays?: boolean
  ) => {
    dispatch(setLoading(true));
    dispatch(storeProducts([], false));
    dispatch(storeProductCount(0));
    setStartIndex(1);
    props.setMoreData(false);

    if (isFormat) {
      if (!(checkIndex !== -1)) {
        formatName.push(item);
      }
    } else {
      if (!(checkIndex !== -1)) {
        genericId.push(item.id?.toString());
        genericName.push(item.name);
      }
    }
    const queryStringUrl = window.location.search;
    const params = new URLSearchParams(queryStringUrl);

    var queryString = "";

    if (isWeekDays) {
      setSelectedWeekdays(item.week);
      setSelectedYear(item.year);
      queryString += queryString !== "" ? "&" : "";
      queryString += `weekNumber=${item.week}`;
      queryString += queryString !== "" ? "&" : "";
      queryString += `weekYear=${item.year}`;
    } else {
      if (selectedWeekdays && selectedYear) {
        queryString += queryString !== "" ? "&" : "";
        queryString += `weekNumber=${selectedWeekdays}`;
        queryString += queryString !== "" ? "&" : "";
        queryString += `weekYear=${selectedYear}`;
      }
    }

    if (params.has("productReleaseEnumValue")) {
      const produtReleaseVal = params.get("productReleaseEnumValue");
      if (selectedWeekdays) {
        queryString += `&productReleaseEnumValue=${produtReleaseVal}`;
      } else {
        queryString += `productReleaseEnumValue=${produtReleaseVal}`;
      }
    }
    if (params.has("customerId")) {
      const customerIdVal = params.get("customerId");
      queryString += queryString !== "" ? "&" : "";
      queryString += `customerId=${customerIdVal}`;
    }

    if (genericId.length) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `genre=${genericId.join(",")}`;
    }

    if (formatName.length) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `formatName=${formatName.join(",")}`;
    }

    if (labelId) {
      queryString += queryString !== "" ? "&" : "";
      queryString += `labelId=${labelId}`;
    }

    // if (queryString === "") {
    //   dispatch(storeReleasesEnumsValue(1));
    // } else {
    //   dispatch(storeReleasesEnumsValue(0));
    // }

    var query = queryString ? `/releases?${queryString}` : `/releases`;
    history.push(query);
  };

  useEffect(() => {
    const handleClearState = (event: Event, isCheck: boolean) => {
      if (isCheck) {
        clearAllFilter(event,true);
      } else {
        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        params.set("weekNumber", "-1");
        params.set("weekYear", "-1");
        setSelectedWeekdays(0);
        setSelectedYear(0);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        history.push(newUrl);
      }
    };

    eventBus.on("clearChildState", handleClearState);

    // Cleanup the listener when component unmounts
    return () => {
      eventBus.removeListener("clearChildState", handleClearState);
    };
  }, []);

  return (
    //  {Loading ? (
    //                     <Loadingtext />
    //                   ) : (
    <>
      {checkMobile ? (
        <div className={`mobile-release-filter-parent-wrap ${selectedWeekdays > 0 || filterLabelName.length > 0 ? 'active-top' : ''}`}>
          <div className="mobile-release-filter-parent">
            {!changeMobileFunction && !isReleaseWeekVisible ? (
              <>
                {mobileFilterName.map((name, index) => {
                  return (
                    <div
                      className="mobile-release-filter"
                      onClick={(event) => handelFilterMobile(event, name)}
                      key={index}
                    >
                      {name}
                    </div>
                  );
                })}
              </>
            ) : isReleaseWeekVisible ? (
              <>
                {weekdays &&
                  weekdays.length > 0 &&
                  weekdays.map((weekday, index) => {
                    return (
                      <div
                        onClick={() => {
                          filterSelection(false, -1, weekday, true);
                        }}
                        key={index}
                        className={`mobile-release-filter ${
                          String(weekday.week) === String(selectedWeekdays)
                            ? "selected-mobile"
                            : ""
                        }`}
                      >
                        {weekday.week}
                        {String(weekday.week) === String(selectedWeekdays) && (
                          <span
                            onClick={(event) => {
                              closeFilter(
                                event,
                                true,
                                -1,
                                weekday.week,
                                false,
                                true
                              );
                            }}
                          >
                            <img
                              src={CloseIcon}
                              alt="close-icon"
                              height={"10px"}
                              width={"10px"}
                            />
                          </span>
                        )}
                      </div>
                    );
                  })}
              </>
            ) : (
              <>
                {currentMobileFilter === "Formats" ? (
                  <>
                    {formats?.map((item: any, index: number) => {
                      var checkIndex = formatName.indexOf(item);

                      return (
                        <div
                          className={`mobile-release-filter ${
                            checkIndex !== -1 ? "selected-mobile" : ""
                          }`}
                          key={index}
                          onClick={() => {
                            filterSelection(true, checkIndex, item);
                          }}
                        >
                          {formatComma.includes(item) ? item + "”" : item}
                          {checkIndex !== -1 && (
                            <span
                              onClick={(event) => {
                                closeFilter(event, true, checkIndex, item);
                              }}
                            >
                              <img
                                src={CloseIcon}
                                alt="close-icon"
                                height={"10px"}
                                width={"10px"}
                              />
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </>
                ) : currentMobileFilter === "Genre" ? (
                  <>
                    {generic?.map((item: any, index: number) => {
                      var checkIndex = genericId?.indexOf(item?.id.toString());
                      return (
                        <div
                          className={`mobile-release-filter ${
                            checkIndex !== -1 ? "selected-mobile" : ""
                          }`}
                          key={index}
                          onClick={() => {
                            filterSelection(false, checkIndex, item);
                          }}
                        >
                          {item?.name}
                          {checkIndex !== -1 && (
                            <span
                              onClick={(event) => {
                                closeFilter(event, false, checkIndex, item);
                              }}
                            >
                              <img
                                src={CloseIcon}
                                alt="close-icon"
                                height={"10px"}
                                width={"10px"}
                              />
                            </span>
                          )}
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <>
                    {specialFilters.map((item, index: number) => (
                      <>
                        <div
                          className={`mobile-release-filter ${
                            productReleaseEnumValue === index + 1
                              ? "selected-mobile"
                              : ""
                          }`}
                          onClick={() => handleClick(index + 1, item)}
                        >
                          {item.title}
                          {productReleaseEnumValue === index + 1 && (
                            <span
                              onClick={(event) => {
                                closeSpecialFilter(event, item);
                              }}
                            >
                              <img
                                src={CloseIcon}
                                alt="close-icon"
                                height={"10px"}
                                width={"10px"}
                              />
                            </span>
                          )}
                        </div>
                      </>
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <>
          {
            <ReleasesHeaderFilters
              labelId={labelId}
              // productReleaseEnumValue={productReleaseEnumValue}
              // setProductReleaseEnumValue={setProductReleaseEnumValue}
              // scrollToTop={scrollToTop}
              // setStartIndex={setStartIndex}
              // rsdSpecialsVisible={rsdSpecialsVisible}
              filterName={filterLabelName}
              closeFilter={closeFilter}
              setFilterShow={setFilterShow}
              filterShow={filterShow}
              initialFunction={initialFunction}
              filterLabelName={filterLabelName}
              setSelectedWeekdays={setSelectedWeekdays}
              selectedWeekdays={selectedWeekdays}
              setSelectedYear={setSelectedYear}
              weekdays={weekdays}
              clearAllFilter={clearAllFilter}
            />
          }{" "}
          {filterShow && (
            <div className="filters-listing">
              <div className="filters-listing-inner">
                {/*  */}
                {
                  <div className="filters-list">
                    <Typography.Title level={4}>Music</Typography.Title>
                    <div className="filters-list-btn">
                      {specialFilters && specialFilters.length > 0 && (
                        <>
                          {specialFilters.map((item, index: number) => (
                            <>
                              <Button
                                className={`rounded-btn ${
                                  productReleaseEnumValue === index + 1
                                    ? "selected"
                                    : ""
                                }`}
                                onClick={() => handleClick(index + 1, item)}
                              >
                                {item.title}
                                {productReleaseEnumValue === index + 1 && (
                                  <span
                                    onClick={(event) => {
                                      closeSpecialFilter(event, item);
                                    }}
                                  >
                                    <img
                                      src={CloseIcon}
                                      alt="close-icon"
                                      height={"10px"}
                                      width={"10px"}
                                    />
                                  </span>
                                )}
                              </Button>
                            </>
                          ))}
                        </>
                      )}
                      {/* {propsValues !== 0 && (
                      <>
                        <Button
                          className={`rounded-btn ${
                            propsValues == 1 ? "selected" : ""
                          }`}
                          onClick={() => handleClick(1)}
                        >
                          {Localize.NewReleases}
                        </Button>
                        <Button
                          className={`rounded-btn ${
                            propsValues == 2 ? "selected" : ""
                          }`}
                          // className={`rounded-btn ${Props.productReleaseEnumValue == 2 || releases_enums_values == 2 ? "selected" : ""
                          //   }`}
                          onClick={() => handleClick(2)}
                        >
                          {Localize.ForthComing}
                        </Button>
                        <Button
                          className={`rounded-btn ${
                            propsValues == 3 ? "selected" : ""
                          }`}
                          // className={`rounded-btn ${Props.productReleaseEnumValue == 3 || releases_enums_values == 3 ? "selected" : ""
                          //   }`}
                          onClick={() => handleClick(3)}
                        >
                          {Localize.Represses}
                        </Button>
                      </>
                    )}
                    {props?.rsdSpecialsVisible === true && (
                      <Button
                        // className={`rounded-btn ${Props.productReleaseEnumValue == 5 || releases_enums_values == 5 ? "selected" : ""
                        //   }`}
                        className={`rounded-btn ${
                          propsValues == 5 ? "selected" : ""
                        }`}
                        onClick={() => handleClick(5)}
                      >
                        {Localize.RsdSpecials}
                      </Button>
                    )} */}
                    </div>
                  </div>
                }
                {/*  */}

                <div className="filters-list">
                  <Typography.Title level={4}>Formats</Typography.Title>
                  <div className="filters-list-btn">
                    {formats?.map((item: any, index: number) => {
                      var checkIndex = formatName.indexOf(item);

                      return (
                        <Button
                          key={index}
                          className={
                            "rounded-btn small" +
                            (checkIndex !== -1 ? " selected" : "")
                          }
                          // disabled={Loading}
                          shape="circle"
                          title={item}
                          onClick={() => {
                            filterSelection(true, checkIndex, item);
                          }}
                        >
                          {formatComma.includes(item) ? item + "”" : item}
                          {checkIndex !== -1 && (
                            <span
                              onClick={(event) => {
                                closeFilter(event, true, checkIndex, item);
                              }}
                            >
                              <img
                                src={CloseIcon}
                                alt="close-icon"
                                height={"10px"}
                                width={"10px"}
                              />
                            </span>
                          )}
                        </Button>
                      );
                    })}
                  </div>
                </div>

                <div className="filters-list genre-wrap">
                  <Typography.Title level={4}>Genres</Typography.Title>
                  <div className="filters-list-btn genre">
                    {generic?.map((item: any, index: number) => {
                      var checkIndex = genericId?.indexOf(item?.id.toString());
                      return (
                        <Button
                          key={index}
                          className={
                            `rounded-btn` +
                            (checkIndex !== -1 ? " selected" : "")
                          }
                          // disabled={Loading}
                          shape="circle"
                          onClick={() => {
                            filterSelection(false, checkIndex, item);
                          }}
                        >
                          {item?.name}
                          {checkIndex !== -1 && (
                            <span
                              onClick={(event) => {
                                closeFilter(event, false, checkIndex, item);
                              }}
                            >
                              <img
                                src={CloseIcon}
                                alt="close-icon"
                                height={"10px"}
                                width={"10px"}
                              />
                            </span>
                          )}
                        </Button>
                      );
                    })}
                  </div>
                </div>
              </div>
              <div className="filter-button-wrapper">
                <div
                  onClick={() => {
                    setFilterShow(false);
                    props.initialFunction();
                  }}
                  className="filter-button"
                >
                  Show Results <ArrowRightOutlined />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default FiltersListing;
